import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useBlogTitles } from "./BlogContent";
import "./BlogCard.css";

export type BlogPost = ReturnType<typeof useBlogTitles>[number];

// Fundo da imagem do post. O post 12 tem uma foto vertical: o enquadramento desce para mostrar os rostos.
export function blogImageStyle(post: BlogPost): React.CSSProperties {
  return {
    backgroundImage: post.imagem ? `url(${post.imagem})` : undefined,
    backgroundPosition: post.id === 12 ? "center 60%" : "center",
  };
}

// Card de artigo: imagem com a data por cima, título, resumo e tempo de leitura. `compact` = versão horizontal,
// sem resumo (coluna lateral dos destaques).
export default function BlogCard({ blog, compact }: { blog: BlogPost; compact?: boolean }) {
  const { t } = useTranslation();

  return (
    <Link to={`/blog/${blog.id}`} className={`cz-blog-card${compact ? " cz-blog-card--compact" : ""}`}>
      <div className="cz-blog-card__media">
        <div className="cz-blog-card__img" style={blogImageStyle(blog)} />
        {!compact && <span className="cz-blog-card__date">{blog.data}</span>}
      </div>
      <div className="cz-blog-card__body">
        {compact && <span className="cz-blog-card__meta-date">{blog.data}</span>}
        <h3 className="cz-blog-card__title">{blog.titulo}</h3>
        {!compact && blog.excerpt && <p className="cz-blog-card__excerpt">{blog.excerpt}</p>}
        <span className="cz-blog-card__foot">
          <Clock size={14} aria-hidden="true" />
          {t("blog.reading_time", { count: blog.minutes, defaultValue: "{{count}} min de leitura" })}
          <span className="cz-blog-card__go" aria-hidden="true">
            <ArrowUpRight size={15} />
          </span>
        </span>
      </div>
    </Link>
  );
}
